export default function Logo({ size = 48 }) {
    return (
        <div
            className="rounded-full flex items-center justify-center shadow-md"
            style={{
                width: size,
                height: size,
                background: "radial-gradient(circle at 30% 30%, #FFD6A8 0%, #D35400 70%)",
                border: "3px solid #FFFFFF",
            }}
            aria-label="شعار تسالي سكة 10"
        >
            <div className="text-center text-white font-black leading-none" style={{ fontSize: size * 0.28 }}>
                <div>تسالي</div>
                <div style={{ fontSize: size * 0.2, marginTop: 2 }}>سكة 10</div>
            </div>
        </div>
    );
}
